import { Store } from 'redux'
import { getTrackedEmail } from 'Lib/TrackingIdentity'

export const SHAHashValue = async (input?: string | null) => {
  if (!input?.trim()) {
    return
  }

  const textAsBuffer = new TextEncoder().encode(input.trim().toLowerCase())
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hash = hashArray
    .map((item) => item.toString(16).padStart(2, '0'))
    .join('')
  return hash
}

export const getHashedEmail = async (store: Store | null): Promise<string | null | undefined> => {
  const trackedEmail = getTrackedEmail(store)

  if (!trackedEmail) {
    return
  }

  return await SHAHashValue(trackedEmail)
}
